import { Button } from "antd";
import React from "react";
import {hasStoryboardEditPermission, selectUser} from "../../actions/userSlice";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { GenerateEmailButton } from "./GenerateEmailButton";
import { selectWorkbook, setCreateWorkbook, setEditWorkbook } from "./storyboardSlice";
import styles from './styles.module.scss';

export type StoryboardButtonsProps = {
    onClickMyStoryboards: () => void
}

export const StoryboardButtons = ({onClickMyStoryboards}: StoryboardButtonsProps) => {
    const dispatch = useAppDispatch()
    const selectedWorkbook = useAppSelector(selectWorkbook)
    const hasEditPermission = useAppSelector(hasStoryboardEditPermission)
    const userDetails = useAppSelector(selectUser)

    return <div className={styles.buttonContainer}>

        <GenerateEmailButton userDetails={userDetails} workbook={selectedWorkbook}/>

        {hasEditPermission ? <Button onClick={() => dispatch(setCreateWorkbook(true))}>Create Storyboard</Button> : null}
        {(hasEditPermission && selectedWorkbook?.canEdit) ? <Button onClick={() => dispatch(setEditWorkbook(true))}>Edit Storyboard</Button> : null}
        <Button type="primary" onClick={onClickMyStoryboards}>My Storyboards</Button>
    </div>
}